import { createAction, props } from "@ngrx/store";
import { BizShopBanner } from "../../models/biz-shop-banner";

export const loadBizShopBanner = createAction("[Shop Banner] Load Biz Shop Banner", props<{ adminId: any }>());
export const loadBizShopBannerSuccess = createAction("[Shop Banner] Load Biz Shop Banner Success", props<{ bizShopBanner: BizShopBanner[] }>());
export const loadBizShopBannerFailure = createAction("[Shop Banner] Load Biz Shop Banner Failure", props<{ error: any }>());
export const clearBizShopBanner = createAction("[Shop Banner] Clear Banner");
